import { Avatar, SegmentedControl } from '@/components/ui';
import { useChild } from './child-context';

/** Shown in the top bar. A single child needs no switcher: just their name. */
export function ChildSwitcher() {
  const { children, child, select } = useChild();
  if (children.length < 2) {
    return (
      <div className="flex items-center gap-2" aria-label="Child">
        <Avatar name={child.name} size="sm" />
        <span className="text-sm font-semibold text-slate-900">{child.name}</span>
      </div>
    );
  }
  return (
    <SegmentedControl
      aria-label="Choose child"
      items={children.map((entry) => ({ value: entry.id, label: entry.firstName }))}
      value={child.id}
      onChange={select}
    />
  );
}
